var React = require('react');

function ArrowLeftWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrowleftwhite_Group_823","data-name":"arrowleftwhite_Group 823","transform":"translate(-929.733 -3520.235)"},[React.createElement("path",{"id":"arrowleftwhite_Path_15","data-name":"arrowleftwhite_Path 15","d":"M1167,145.774l5.873,5.873,5.873-5.873","transform":"translate(1082.795 2353.942) rotate(90)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("line",{"id":"arrowleftwhite_Line_68","data-name":"arrowleftwhite_Line 68","x1":"15","transform":"translate(931.5 3526.8)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

ArrowLeftWhite.defaultProps = {"width":"16.767","height":"13.161","viewBox":"0 0 16.767 13.161"};

module.exports = ArrowLeftWhite;

ArrowLeftWhite.default = ArrowLeftWhite;
